import { Box, Button, Container, Typography, useMediaQuery } from "@mui/material";
import plano_individual from "../../../../assets/images/planos/plano-individual.jpg";
import { styleImage, styleTitle } from ".";


const Individual: React.FC<{ setPlanoAtual(newValue: string): void }> = ({ setPlanoAtual }) => {

    const isMobile = useMediaQuery("(max-width:768px)");

    return (
        <Box p={isMobile ? 0 : 2} >
            <Container 
                style={{
                    display:"flex" ,
                    alignItems:"center" ,
                    justifyContent:"space-between",
                    flexDirection: isMobile ? "column" :"row"
                }}
            >
            <Box 
                flex={1} 
                width={"100%"}
                height="300px" 
                bgcolor="#e0e0e0" 
                display="flex" 
                alignItems="center" 
                justifyContent="center"
                borderRadius="8px"
            >
                <img style={styleImage} src={plano_individual} />
                
            </Box>
            <Box flex={1} ml={isMobile ? 0 : 4}>
                <Typography variant={ isMobile ? "h6" : "h5" } style={styleTitle} fontWeight="bold">
                Plano individual Innova
                </Typography>
                <Typography variant="body1" color="textSecondary" mt={2} textAlign="justify">
                Cuidados personalizados e qualidade em cada atendimento, pensando sempre no 
                seu bem-estar: 
                </Typography>
                <Typography variant="body1" color="textSecondary" mt={2} textAlign="justify">
                Atendimento personalizado para cada beneficiário 
                Rede de médicos, clínicas e hospitais de alta qualidade 
                Tecnologia integrada para um atendimento humanizado 
                Acesso facilitado e cobertura completa para cuidar de você.
                </Typography>
                <Box mt={3} mb={1} display="flex" justifyContent={ isMobile ? "center" : "flex-end"} gap={2}>
                    <Button variant="contained" color="warning" onClick={() => setPlanoAtual("individual")}>
                        FALE COM A GENTE
                    </Button>
                </Box>
            </Box>
            
            </Container>
        </Box>
    )
}
export default Individual;